// extracted by mini-css-extract-plugin
export default {"Page":"notFound_page_Page__wjU1s","PageContent":"notFound_page_PageContent__rSFXm","LogoImage":"notFound_page_LogoImage__8RTIQ","GoHomeButton":"notFound_page_GoHomeButton__PQyNV"};